import { Button, message, Space } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import React from 'react';
import type { Fetcher } from 'swr';
import { z } from 'zod';

import axios from '@/lib/axios';

import EditButtonWithModal from './EditButtonWithModal';
import type { Locker } from './types';
import { lockerSchema } from './types';

const pageSchema = z.object({
  houseNumbers: z.array(z.string()),
  lockers: z.array(lockerSchema),
});

export const pageDataFetcher: Fetcher<{
  houseNumbers: string[];
  lockers: (Locker & { key: string })[];
}> = async (url: string) => {
  const { data } = await axios.get(url);
  const { houseNumbers, lockers } = pageSchema.parse(data);
  return {
    houseNumbers,
    lockers: lockers.map((locker) => ({ ...locker, key: locker.id })),
  };
};

export const handleOpen = async (lockerId: string) => {
  try {
    await axios.post('/ezcon/api/ultraLocker/admin/openLocker', {
      lockerId,
    });
    message.success('開啟成功');
  } catch (error) {
    console.error(error);
    message.error('開啟失敗');
  }
};

const staticColumns: ColumnsType<Locker> = [
  {
    key: 'name',
    dataIndex: 'name',
    title: '櫃位',
  },
  {
    key: 'size',
    dataIndex: 'size',
    title: '類型',
  },
  {
    key: 'status',
    dataIndex: 'status',
    title: '狀態',
  },
  {
    key: 'houseNumber',
    dataIndex: 'houseNumber',
    title: '收件戶號',
  },
  {
    key: 'time',
    dataIndex: 'time',
    title: '置物時間',
    render(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '';
    },
  },
];

export const createColumns = (houseNumbers: string[], mutate: () => void) => {
  const columns: typeof staticColumns = [
    ...staticColumns,
    {
      key: 'id',
      dataIndex: 'id',
      title: '操作',
      render(_, record) {
        return (
          <Space direction="horizontal">
            <EditButtonWithModal
              locker={record}
              houseNumbers={houseNumbers}
              mutate={mutate}
            />
            <Button type="primary" onClick={() => handleOpen(record.id)}>
              開啟
            </Button>
          </Space>
        );
      },
    },
  ];
  return columns;
};
